
import { Box, Button, Paper, TextField } from "@mui/material";
import { Typography } from "components/ui";
import React from "react";
import { ContainerStyle } from "../styled";

const JoinRoom = ({
    inputCode,
    setInputCode,
    userName,
    setUserName,
    handleJoinRoom,
}) => {
    return (
        <ContainerStyle sx={{ pt: 5, textAlign: "center" }}>
            <Typography $bolds $size="2.5em" color="primary">
                🎲 Lucky Dice
            </Typography>
            <Paper
                elevation={3}
                sx={{
                    mt: 4,
                    p: 4,
                    borderRadius: 4,
                    maxWidth: 500,
                    mx: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <TextField
                    label="Room Code"
                    fullWidth
                    value={inputCode}
                    onChange={(e) => setInputCode(e.target.value)}
                    variant="outlined"
                />
                <TextField
                    label="ชื่อของคุณ"
                    fullWidth
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                />
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleJoinRoom}
                    sx={{ py: 1.5, borderRadius: 2 }}
                >
                    JOIN ROOM
                </Button>
            </Paper>
        </ContainerStyle>
    );
};

export default JoinRoom;
